import { render } from "./TourErrorModal.vue?vue&type=template&id=1289768c"
import script from "./TourErrorModal.vue?vue&type=script&lang=js"
export * from "./TourErrorModal.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "1289768c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1289768c', script)) {
    api.reload('1289768c', script)
  }
  
  module.hot.accept("./TourErrorModal.vue?vue&type=template&id=1289768c", () => {
    api.rerender('1289768c', render)
  })

}

script.__file = "resources/js/Pages/Tour/Partials/TourErrorModal.vue"

export default script